import {NgModule} from '@angular/core';
import {SharedModule} from "../../shared.module";
import {AdminRoutingModule} from "./admin-routing.module";
import {AdminComponent} from "./admin.component";
import {ShopSessionDashboardComponent} from "./shop-session-dashboard/shop-session-dashboard.component";
import {TimeAgoPipe} from "../common/time-ago.pipe";
import {SsdSessionDataComponent} from "./shop-session-dashboard/data/ssd-session-data.component";
import {SsdSessionComponent} from "./shop-session-dashboard/sessions/ssd-session.component";
import {SsdTabShareComponent} from "./shop-session-dashboard/share/ssd-tab-share.component";
import {SsdTotalsTableComponent} from "./shop-session-dashboard/totals-table/ssd-totals-table.component";
import {SsdTabSummaryComponent} from "./shop-session-dashboard/summary/ssd-tab-summary.component";
import {SsdRealtimeChartComponent} from "./shop-session-dashboard/realtime-chart/ssd-realtime-chart.component";
import {CelebrateComponent} from "./shop-session-dashboard/celebrate/celebrate.component";
import {SsdTabRealtimeComponent} from "./shop-session-dashboard/realtime/ssd-tab-realtime.component";
import {UniversalButtonModule} from "@usana/ux/universal-components/button";

@NgModule({
    imports: [
        SharedModule,
        AdminRoutingModule,
        UniversalButtonModule
    ],
    providers: [
        TimeAgoPipe
    ],
    declarations: [
        AdminComponent,
        CelebrateComponent,
        ShopSessionDashboardComponent,
        SsdRealtimeChartComponent,
        SsdTabRealtimeComponent,
        SsdSessionComponent,
        SsdTabShareComponent,
        SsdSessionDataComponent,
        SsdTabSummaryComponent,
        SsdTotalsTableComponent,
        TimeAgoPipe,
    ],

})
export class AdminModule {
}
